module.exports = __webpack_public_path__ + "static/media/specific-risk-green.f22b7673.svg";